import { render, staticRenderFns } from "./playcards.vue?vue&type=template&id=0d1e304e&lang=pug"
import script from "./playcards.vue?vue&type=script&lang=js"
export * from "./playcards.vue?vue&type=script&lang=js"
import style0 from "./playcards.vue?vue&type=style&index=0&id=0d1e304e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports